import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, align = "center" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-12 sm:mb-16`}>
    {eyebrow && (
      <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-orange-500 font-semibold mb-4">
        {eyebrow}
      </p>
    )}
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
      {title}
    </h2>
    {sub && <p className="mt-4 text-base sm:text-lg text-slate-400 leading-relaxed">{sub}</p>}
  </Reveal>
);

export const staggerContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};
